import confirm from "./confirm/confirm";

export default {
  install: (app) => {
    app.use(vuetify);
    app.use(router);
    app.use(pinia);
    app.use(api);
    app.use(socket);
    app.use(utilities);
    app.use(validators);
    app.use(confirm);
    app.use(store);
    app.use(sanitize);
  }
}
